import type { App } from "vue";
import errorShake from "@/directives/errorShake";

export default {
  install(app: App) {
    app.directive("error-shake", errorShake);
  },
};
